import store from "@/store/index"
import { utils } from "../store/helpers"
import json_data from "@/components/shared/json-files/all-obj-fields.json"

const removeEscapeChars = (string) => {
  let clean_string = ""
  string.split("").forEach((char, index) => {
    if (index != 0 && index != string.length - 1 && char == "'") {
      clean_string += "\\'"
    } else if (char != "\\") {
      clean_string += char
    }
  })
  return clean_string
}

const transformServerFilterToMetricFilter = (input_filter, in_playbook, for_playbook_action, result_refs) => {
  let other_metrics = []
  Object.entries(json_data).map((item) => {
    other_metrics.push({ ...item[1] })
  })

  //input_filter = "( company_actual_value > 234 or company_facebook_followers_rs > 23 ) or ! ( company_alexa_global_rank_rs > 23 or company_facebook_avatar_rs == se )"

  //input_filter = input_filter.split(" ")[0].length > 1 ? `( ${input_filter.slice(1, input_filter.lenght - 1)} )` : input_filter
  input_filter = input_filter.split(" ")

  if (input_filter.length > 1 && input_filter[0] !== "(") {
    input_filter.unshift("(")
  }
  const input_filter_modified = []

  let search_value = ""
  let inside = false

  input_filter.forEach((v) => {
    if (v[0] == "'" && v[v.length - 1] == "'") {
      input_filter_modified.push(`${removeEscapeChars(v)}`)
      search_value = ""
    } else if (v[0] == "'" || v == "today()") {
      inside = true
      search_value += removeEscapeChars(v)
    } else if (v[v.length - 1] == "'" || v.includes("timedelta")) {
      inside = false
      search_value += ` ${v}`
      input_filter_modified.push(removeEscapeChars(search_value))
      search_value = ""
    } else if (inside == true) {
      search_value += ` ${removeEscapeChars(v)}`
    } else {
      if (v) {
        input_filter_modified.push(removeEscapeChars(v))
      }
    }
  })

  let filter = []
  let is_simple_filter = true
  if (input_filter_modified[0] === "not") {
    is_simple_filter = false
  }

  let clause, operator, item_type, item
  let not = false
  input_filter_modified.forEach((filtr, index) => {
    let filtr_calc = filtr
    let result_ref = ""
    if (filtr.includes(`\${`)) {
      if (
        filtr.replace(`\${`, "").replace(`}`, "").split(".")[1] == "id" ||
        filtr.replace(`\${`, "").replace(`}`, "").split(".")[1] == "parent"
      ) {
        //Do nothing
      } else {
        filtr_calc = filtr.replace(`\${`, "").replace(`}`, "").split(".")[1]
        result_ref = filtr.replace(`\${`, "").replace(`}`, "").split(".")[0]
      }
    }

    if (filtr === "or") {
      is_simple_filter = false
    }
    if (input_filter_modified[index] == "not") {
      not = true
    }

    if (input_filter_modified[index] == "(") {
      if (input_filter_modified[index + 4] == ")") {
        if (input_filter_modified[index - 1] == "not") {
          not = true
          clause = { label: "Not All", value: "!(and", inner_operator: "and" }
          item_type = "clause"
        } else {
          clause = { label: "All", value: "(and", inner_operator: "and" }
          item_type = "clause"
        }
      } else {
        if (input_filter_modified[index - 1] == "not") {
          not = true
          if (input_filter_modified[index + 4] == "and") {
            clause = utils.clone({ hint: "Do not match all of", label: "Not All", value: "!(and", inner_operator: "and" })
          } else {
            clause = utils.clone({ hint: "Do not match at least one of", label: "None of", value: "!(or", inner_operator: "or" })
          }
        } else {
          clause = utils.clone(store.state.data.filter_logic_clauses.find((x) => x.inner_operator == input_filter_modified[index + 4]))
        }
        item_type = "clause"
      }
      item = { clause: clause, item_type: item_type }
      filter.push(item)
    } else if (
      utils.getMetricByReferenceName(filtr_calc.toString()) ||
      filtr_calc == "owner__id" ||
      filtr_calc == "co_owners__id" ||
      filtr_calc == "owner__email" ||
      filtr_calc == "object_type" ||
      filtr_calc == "parent" ||
      filtr_calc == "id" ||
      filtr_calc == "record" ||
      filtr_calc == "co_owners__email" ||
      filtr_calc == "tags__name" ||
      filtr_calc == "tags__id" ||
      filtr_calc == "parent__id" ||
      filtr_calc == "parent__name" ||
      filtr_calc == "origins" ||
      filtr_calc == "top_parent" ||
      other_metrics.find((metric) => filtr_calc.includes(metric.reference_name))
    ) {
      let forecast_metrics = [
        {
          reference_name: `forecasts__forecast_status`,
          name: "Forecast Status",
          data_type: "String",
          input_type: "Select",
          input_options: { choices: ["forecasted", "actual"] }
        },
        {
          reference_name: `forecasts__forecast_type`,
          name: "Forecast Type",
          data_type: "String",
          input_type: "Select",
          input_options: { choices: ["non-renewable", "renewable"] }
        },
        { reference_name: `forecasts__forecast_value`, name: "Forecast Value", data_type: "Number", input_type: "Number" }
      ]
      let owner_co_owner_filer = [
        { reference_name: `owner__email`, name: "Owner", data_type: "String", input_type: "Text" },
        { reference_name: `origins`, name: "Origin", data_type: "String", input_type: "Text" },
        { reference_name: `parent__name`, name: "Parent", data_type: "String", input_type: "Text" },
        { reference_name: `co_owners__email`, name: "Co-Owner", data_type: "String", input_type: "Text" },
        { reference_name: `owner__id`, name: "Owner", data_type: "String", input_type: "Text" },
        { reference_name: `co_owners__id`, name: "Co-Owner", data_type: "String", input_type: "Text" }
      ]

      let parent_filters = [
        { reference_name: `parent__id`, name: "Direct Parent", data_type: "String", input_type: "Text" },
        { reference_name: `parent__name`, name: "Direct Parent", data_type: "String", input_type: "Text" },
        { reference_name: `top_parent`, name: "Top Parent", data_type: "String", input_type: "Text" }
      ]
      let tags_filters = [
        { reference_name: `tags__name`, name: "Assigned tags", data_type: "String", input_type: "Text" },
        { reference_name: `tags__id`, name: "Assigned tags", data_type: "String", input_type: "Text" }
      ]

      if (other_metrics.find((metric) => filtr_calc.includes(metric.reference_name))) {
        let arr = filtr_calc.split("__")
        let index = other_metrics.findIndex((x) => x.reference_name == `${arr[0] + "__"}`)

        if (index !== -1 && other_metrics[index]) {
          other_metrics[index]["reference_name"] = filtr_calc

          other_metrics[index]["option"] = arr.length == 3 ? other_metrics[index].options[arr[2]] : other_metrics[index].options[arr[1]]

          other_metrics[index].data_type =
            arr.length == 3
              ? other_metrics[index].options[arr[1] + "__" + arr[2]]?.data_type
              : other_metrics[index].options[arr[1]]?.data_type
          other_metrics[index].input_type =
            arr.length == 3
              ? other_metrics[index].options[arr[1] + "__" + arr[2]]?.input_type
              : other_metrics[index].options[arr[1]]?.input_type
        }
      }

      let playbook_metrics = [
        {
          reference_name: `object_type`,
          name: "Object Type",
          data_type: "Playbook",
          input_type: "Text"
        },
        {
          reference_name: `parent`,
          name: "Parent",
          data_type: "Playbook",
          input_type: "Text"
        },
        {
          reference_name: `id`,
          name: "Result Reference",
          data_type: "Playbook",
          input_type: "Text"
        },
        {
          reference_name: `record`,
          name: "Record",
          data_type: "Playbook",
          input_type: "Text"
        }
      ]

      let metric = utils.clone(
        store.state.metrics
          .concat(forecast_metrics)
          .concat(owner_co_owner_filer)
          .concat(tags_filters)
          .concat(other_metrics)
          .concat(playbook_metrics)
          .concat(parent_filters)
          .find((x) => x.reference_name == filtr_calc)
      )

      metric.operators = store.state.data.filter_operators.filter(
        (o) => o.for.split("_").findIndex((t) => t.toLowerCase() == metric.data_type?.toLowerCase()) != -1
      )

      if (in_playbook) {
        if (for_playbook_action) {
          metric.operators = store.state.data.metric_action_options.filter(
            (o) => o.for.split("_").findIndex((t) => t.toLowerCase() == metric.data_type.toLowerCase()) != -1
          )
        } else {
          metric.operators = metric.operators
            .concat(store.state.data.playbook_filter_operators)
            .filter((o) => o.for.split("_").findIndex((t) => t.toLowerCase() == metric.data_type.toLowerCase()) != -1)
        }
      }

      const regex = /-/g
      if (result_ref) {
        metric["result_reference"] = result_refs.find(
          (r) => utils.replaceLast(r.name.toLowerCase().replaceAll(" ", "_"), "_record", "__record") == result_ref
        )
      }

      if (input_filter_modified[index + 2] == "None") {
        if (input_filter_modified[index + 1] == "==") {
          metric.operator = metric.operators.find((op) => op.value == "__ISNULL__")
        } else {
          metric.operator = metric.operators.find((op) => op.value == "__IS_NOT_NULL__")
        }
      } else if (input_filter_modified[index + 2]?.includes("timedelta") || input_filter_modified[index + 2]?.includes("today")) {
        if (input_filter_modified[index + 1] == "<") {
          metric.operator = metric.operators.find((op) => op.value == "__DAYS_MORE_THAN_X_DAYS_AGO__")
        } else if (input_filter_modified[index + 1] == ">") {
          metric.operator = metric.operators.find((op) => op.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__")
        } else if (input_filter_modified[index + 1] == "==" || input_filter_modified[index + 1] == "in") {
          if (input_filter_modified[index + 2].split(" ")[1] == "-") {
            metric.operator = metric.operators.find((op) => op.value == "__DAYS_EXACT_DAYS_AGO__")
          } else {
            metric.operator = metric.operators.find((op) => op.value == "__DAYS_EXACT_DAYS_FROM_NOW__")
          }
        } else {
          if (input_filter_modified[index + 3] == "-") {
            metric.operator = metric.operators.find((op) => op.value == "__DAYS_WITHIN_LAST_X_DAYS__")
          } else {
            metric.operator = metric.operators.find((op) => op.value == "__DAYS_WITHIN_NEXT_X_DAYS__")
          }
        }
      } else if (
        (metric.data_type == "Date" || metric.data_type == "DateTime") &&
        input_filter_modified[index + 1] === "in" &&
        (input_filter_modified[index + 2]?.match(regex) || []).length == 4
      ) {
        metric.operator = metric.operators.find((op) => op.value == "__DAYS_WITHIN_RANGE__")
      } else if (input_filter_modified[index + 1] === "in" && !not) {
        metric.operator = metric.operators.find((op) => op.value == "__INCLUDES__")
      } else if (input_filter_modified[index + 1] === "in") {
        metric.operator = metric.operators.find((op) => op.value == "__EXCLUDES__")
        //remove the qoutes from the metric.value if they exists
      } else {
        metric.operator = metric.operators.find((op) => op.value == input_filter_modified[index + 1])
      }

      if (input_filter_modified[index + 1] === "in" || input_filter_modified[index + 1] === "==") {
        if (input_filter_modified[index + 2] == "None") {
          metric.value = "True"
        } else if (input_filter_modified[index + 2].includes("timedelta")) {
          const clean_number = input_filter_modified
            .find((f) => f.includes("timedelta"))
            .split("timedelta(")[1]
            .split(")")[0]
          // const number = utils.clone(input_filter_modified[index + 2].split(" ")[2].split("(")[1])
          // const clean_number = number.slice(0, number.length - 1)
          metric.value = clean_number
        } else {
          metric.value = utils.clone(input_filter_modified[index + 2])
          metric["modified_value"] = utils.clone(input_filter_modified[index + 2])
        }
      } else if (input_filter_modified[index + 1] === "!=") {
        if (input_filter_modified[index + 2] == "None") {
          metric.value = "False"
        } else {
          metric.value = utils.clone(input_filter_modified[index + 2])
        }
      } else {
        if (input_filter_modified[index + 2]?.includes("timedelta")) {
          const number = utils.clone(input_filter_modified[index + 2].split(" ")[2].split("(")[1])
          const clean_number = number.slice(0, number.length - 1)
          metric.value = parseInt(clean_number) < 0 ? clean_number * -1 : clean_number
        } else {
          metric.value = utils.clone(input_filter_modified[index + 2])
        }
      }
      filter.push(metric)
    } else if (input_filter_modified[index - 1] == ")" && (input_filter_modified[index] == "and" || input_filter_modified[index] == "or")) {
      item_type = "operator"
      operator = utils.clone(store.state.data.filter_logic_operators.find((x) => x.value == input_filter_modified[index]))
      item = { item_type: item_type, operator: operator }
      filter.push(item)
    }
    other_metrics = []
    Object.entries(json_data).map((item) => {
      other_metrics.push({ ...item[1] })
    })
  })

  const filter_with_cleaner_string_values = []
  filter.forEach((item) => {
    if (item.data_type == "String" || item.data_type == "List" || item.data_type == "Json") {
      item.value = item.value.replace(/[']+/g, "")
    }
    filter_with_cleaner_string_values.push(item)
  })

  return { filter: filter_with_cleaner_string_values, is_simple_filter }
}

const transformMetricFilterToServerFilter = (filter) => {
  if (filter == null || filter.length == 0) {
    return { filter_metrics: [], filter: "", valid: false }
  }

  let metrics_ids = filter.filter((item) => item.item_type != "clause" && item.item_type != "operator").map((metric) => metric.id)
  if (metrics_ids.length == 0) {
    return { filter_metrics: [], filter: "", valid: false }
  }
  let transformed_filter = []
  let last_clause = null
  try {
    filter.forEach((item, index) => {
      if (item.item_type == "clause") {
        last_clause = item.clause
        if (last_clause?.value == "(and" || last_clause?.value == "(or") {
          if (
            (filter, filter[index + 1]?.operator.value === "__EXCLUDES__") ||
            (filter[index + 1]?.operator.value === "!=" && filter[index + 1].value?.includes(","))
          ) {
            transformed_filter.push("not")
          }
          transformed_filter.push("(")
        } else if (last_clause?.value == "!(and" || last_clause?.value == "!(or") {
          transformed_filter.push("not")
          transformed_filter.push("(")
        }
      } else if (item.item_type == "operator") {
        // close the last clause
        transformed_filter.push(")")
        // append the operator
        transformed_filter.push(item.operator.value)
      } else {
        let full_reference_name = item.reference_name
        if (item.result_reference) {
          full_reference_name = `\${${utils.replaceLast(
            item.result_reference.name.toLowerCase().replaceAll(" ", "_"),
            "_record",
            "__record"
          )}.${item.reference_name}}`
        }

        if (item.operator.value === "__DAYS_WITHIN_RANGE__") {
          transformed_filter.push(...[full_reference_name, "in", item.modified_value])
        } else if (item.operator.value === "__DAYS_WITHIN_LAST_X_DAYS__") {
          transformed_filter.push(...[full_reference_name, "in", `(today() - timedelta(${String(item.value).trim()}),today())`])
        } else if (item.operator.value === "__DAYS_MORE_THAN_X_DAYS_AGO__") {
          transformed_filter.push(...[full_reference_name, "<", `today() - timedelta(${String(item.value).trim()})`])
        } else if (item.operator.value === "__DAYS_EXACT_DAYS_AGO__") {
          transformed_filter.push(...[full_reference_name, "==", `today() - timedelta(${String(item.value).trim()})`])
        } else if (item.operator.value === "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__") {
          transformed_filter.push(...[full_reference_name, ">", `today() + timedelta(${String(item.value).trim()})`])
        } else if (item.operator.value === "__DAYS_WITHIN_NEXT_X_DAYS__") {
          transformed_filter.push(...[full_reference_name, "in", `(today(),today() + timedelta(${String(item.value).trim()}))`])
        } else if (item.operator.value === "__DAYS_EXACT_DAYS_FROM_NOW__") {
          transformed_filter.push(...[full_reference_name, "==", `today() + timedelta(${String(item.value).trim()})`])
        } else if (item.operator.value === "__INCLUDES__") {
          // enclose the value in single quotes if it does not contain them
          if (item?.value[0] != "'" && item?.value[item?.value.length - 1] != "'") {
            transformed_filter.push(...[full_reference_name, "in", `'${item.value}'`])
          } else {
            transformed_filter.push(...[full_reference_name, "in", removeEscapeChars(item.value)])
          }
        } else if (item.operator.value === "__EXCLUDES__") {
          // enclose the value in single quotes if it does not contain them
          transformed_filter.push(...[full_reference_name, "in", `'${item.value}'`])
        } else if (
          item.operator.value === "=" &&
          (item.data_type == "String" ||
            item.data_type == "List" ||
            item.data_type === "Json" ||
            item.data_type === "Date" ||
            item.data_type === "DateTime")
        ) {
          transformed_filter.push(...[full_reference_name, item.operator.value, `'${removeEscapeChars(item.value)}'`])
        } else if (item.operator.value === "==" && (item.data_type == "String" || item.data_type == "List")) {
          transformed_filter.push(
            ...[
              full_reference_name,
              Array.isArray(item.value) || item.value.includes(",") ? "in" : "==",
              `'${removeEscapeChars(item.value)}'`
            ]
          )
        } else if (
          item.operator.value === "==" &&
          (item.data_type === "Json" || item.data_type === "Date" || item.data_type === "DateTime")
        ) {
          let value_calc = removeEscapeChars(item.value)

          if (value_calc[0] !== "'") {
            value_calc = `'${value_calc}'`
          }
          transformed_filter.push(...[full_reference_name, "==", `${value_calc}`])
        } else if (item.data_type === "Boolean") {
          transformed_filter.push(...[full_reference_name, item.operator.value, `${item.value.toLowerCase() == "true" ? "True" : "False"}`])
        } else if (
          item.operator.value === "!=" &&
          (item.data_type === "String" || item.data_type === "Json" || item.data_type === "Date" || item.data_type === "DateTime")
        ) {
          let value_calc = item.value
          if (value_calc[0] !== "'") {
            value_calc = `'${removeEscapeChars(value_calc)}'`
          }
          transformed_filter.push(...[full_reference_name, item.value.includes(",") ? "in" : "!=", `${value_calc}`])
        } else if (item.operator.value === "__ISNULL__") {
          transformed_filter.push(...[full_reference_name, "==", `None`])
        } else if (item.operator.value === "__IS_NOT_NULL__") {
          transformed_filter.push(...[full_reference_name, "!=", `None`])
        } else if (
          (item.operator.value === ">" || item.operator.value === "<") &&
          (item.data_type === "Date" || item.data_type === "DateTime")
        ) {
          let value_calc = removeEscapeChars(item.value)

          if (value_calc[0] !== "'") {
            value_calc = `'${value_calc}'`
          }

          transformed_filter.push(...[full_reference_name, item.operator.value, `${value_calc}`])
        } else if (item.data_type === "List") {
          let value = item.value
          if (!Array.isArray(value)) {
            value = value.split(",")
          }
          transformed_filter.push(...[full_reference_name, "in", value])
        } else {
          transformed_filter.push(...[full_reference_name, item.operator.value, item.value])
        }

        if (index < filter.length - 1 && filter[index + 1].item_type != "clause" && filter[index + 1].item_type != "operator") {
          // append clause operator 'operator between metrics'
          transformed_filter.push(last_clause.inner_operator)
        }
        if (index == filter.length - 1) {
          // close the last clause
          transformed_filter.push(")")
        }
      }
    })
  } catch (error) {
    return { filter_metrics: metrics_ids, filter: "", valid: false }
  }

  if (transformed_filter[0] !== "(" && transformed_filter[0] !== "not") {
    transformed_filter.unshift("(")
  }

  return { filter_metrics: metrics_ids, filter: transformed_filter.join(" "), valid: filter.filter((m) => m.value == "").length == 0 }
}

export { transformMetricFilterToServerFilter, transformServerFilterToMetricFilter }
